<template>
    <ui-modal>
        <template #header>
            <h3 v-text="title" class="text-center mb-1" />
            <h5 v-if="selectedOperator" v-text="existingContract.full_name" class="cux-exclude text-center mb-0" />
        </template>

        <page-preloader
            v-if="createStatus === 'loading' || loader"
            min-height="10rem"
            loading-status="loading"
        />
        <div v-else-if="hasNoContract" v-text="'Brak wyników'" />
        <operator-contract-location-form
            v-else
            class="p-3"
            :id="locationId"
            :initial-contract="contract"
            :selected-operator="selectedOperator"
            @on-change="contract = $event"
        />

        <template #footer>
            <the-btn
                class="btn-outline-custom"
                text="Zamknij"
                @click="$emit('close-modal')"
            />
            <the-btn
                v-tooltip="tooltipText"
                class="btn-secondary"
                text="Zapisz umowę"
                :disabled="!isContractValid || createStatus === 'loading'"
                @click="saveContract"
            />
        </template>
    </ui-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { OPERATOR_CODES } from '@/utils/constants/drs/operators'

export default {
    data: () => ({
        loader: false,
        locationId: null,
        contract: null,
        existingContract: null,
        hasNoContract: false
    }),
    created() {
        this.initData()
    },
    computed: {
        ...mapGetters('drsOperators', {
            fractions: 'getFractions',
            createStatus: 'getCreateContractsStatus',
            getServiceId: 'getServiceIdByOperatorId'
        }),
        args () {
            return this.$store.getters.modalState.args
        },
        selectedOperator() {
            return this.args.selectedOperator
        },
        isEditMode() {
            return this.args.mode === 'edit'
        },
        title () {
            return this.isEditMode ? 'Edycja umowy z Operatorem' : 'Rejestracja umowy z Operatorem'
        },
        tooltipText() {
            return !this.isContractValid
                ? `Aby zarejestrować umowę, uzupełnij dane dla zaznaczonych sklepów
                    i wybierz przynajmniej jedną frakcję dla każdego z nich.`
                : null
        },
        isContractValid() {
            if (!this.contract) return

            const {
                fractions,
                startDate,
                endDate,
                indefinite,
                collectionPointId,
                invalidCollectionPointId,
                retailerToken
            } = this.contract

            const isRetailerToken = this.selectedOperator.code !== OPERATOR_CODES.POLKA || retailerToken.trim()
            const enabledFractions = fractions?.filter(f => f.enabled)

            return (
                collectionPointId && !invalidCollectionPointId &&
                isRetailerToken &&
                startDate &&
                (endDate || indefinite) &&
                enabledFractions.length &&
                enabledFractions.every(f => +f.handlingFee > 0)
            )
        }
    },
    methods: {
        ...mapActions('drsOperators', [
            'createContractAndUpdateData',
            'editLocationContractAndUpdateData',
            'fetchExternalData'
        ]),
        async initData() {
            this.existingContract = this.args.existingContract
            this.locationId = this.existingContract.locationId

            if (!this.isEditMode) {
                this.contract = undefined
                return
            }

            this.loader = true

            try {
                // load collectionPointId
                const externalData = await this.fetchExternalData({
                    locationId: this.existingContract.locationId,
                    operatorServiceIds: [this.getServiceId(this.selectedOperator.id)]
                })

                this.existingContract = {
                    ...this.existingContract,
                    collectionPointId: externalData[0]?.collection_point_id || '',
                    retailerToken: externalData[0]?.retailer_token || ''
                }

                // set contract data for edit mode
                const {
                    contractId,
                    startDate,
                    endDate,
                    fractions,
                    collectionPointId,
                    retailerToken
                } = this.existingContract

                this.contract = {
                    contractId,
                    startDate,
                    endDate,
                    collectionPointId,
                    retailerToken,
                    invalidCollectionPointId: false,
                    indefinite: !endDate,
                    fractions: this.fractions.map(fr => {
                        const frData = fractions.find(({ id }) => id === fr.id)
                        return {
                            ...fr,
                            enabled: !!frData,
                            handlingFee: frData?.handlingFee || 0
                        }
                    })
                }
            } catch (err) {
                console.error(err)
                this.hasNoContract = true
            } finally {
                this.loader = false
            }
        },
        async saveContract() {
            if (!this.isContractValid) return

            const operatorServiceId = this.selectedOperator.id
            if (this.isEditMode) {
                await this.editLocationContractAndUpdateData({
                    operatorServiceId,
                    prev: this.existingContract,
                    curr: {
                        ...this.contract,
                        fractions: this.contract.fractions.filter(el => el.enabled)
                    }
                })
            } else {
                await this.createContractAndUpdateData({
                    operatorServiceId,
                    locationId: this.locationId,
                    companyId: this.existingContract.companyId,
                    contract: this.contract
                })
            }

            if (this.createStatus === 'ok' || this.createStatus === 'error') {
                const isOk = this.createStatus === 'ok'
                this.$store.dispatch('addNotification', {
                    type: isOk ? 'success' : 'danger',
                    content: isOk ? 'Zapisano umowę' : 'Przy zapisie danych wystąpił błąd'
                })
            }
            this.$store.dispatch('toggleModal', false)
        }
    }
}
</script>